import { Component, OnInit } from '@angular/core';
import { MenuItemEnum } from 'src/app/enums/menuItemEnum';
import { AuthService } from 'src/app/services';
import { PageOptionsPopUpService } from './page-options-pop-up.service';

@Component({
    selector: 'app-page-options-pop-up-button',
    templateUrl: './page-options-pop-up-button.component.html',
    styleUrls: ['./page-options-pop-up-button.component.scss'],
    standalone: false
})
export class PageOptionsPopUpButtonComponent implements OnInit {

	public visible: boolean;

	constructor(
		public pageOptionsPopUpService: PageOptionsPopUpService,
		public authService: AuthService,
	) { }

	ngOnInit(): void {
		this.authService.getPermissions(
			{
				showLoadingIndicator: false,
			}
		).subscribe(
			{
				next: (rolePermissions) => {

					let roleHasAccessToGeneralSettings: boolean = false;
					let roleHasAccessToSelectionOptions: boolean = false;

					for (let a = 0; a < rolePermissions.length; a++) {
						const rolePermission = rolePermissions[a];

						if (rolePermission.menuId === MenuItemEnum.GeneralSettings) {
							roleHasAccessToGeneralSettings = true;
						}

						if (rolePermission.menuId === MenuItemEnum.SelectionOptions) {
							roleHasAccessToSelectionOptions = true;
						}

						if (roleHasAccessToGeneralSettings && roleHasAccessToSelectionOptions) {
							this.visible = true;

							break;
						}
					}
				}
			}
		);
	}
}
